import { store } from "../store";
import * as HelperSrc from "../HelperSrc";
import * as Instance from "../Instance";
import * as ModelHelperSrc from "../model/HelperSrc";

async function uploadFile(file: File, workbook: string): Promise<string> {
    HelperSrc.setLastActivity();

    const formData = new FormData();
    formData.append("name", file.name);
    formData.append("filedata", file);

    const result = await Instance.api.post<ModelHelperSrc.Iresponse>(`/client/${store.db || ""}/workbook/${workbook}/upload/`, {}, formData);

    if (result.data.message.error) {
        return result.data.message.error;
    }

    return "";
}

export { uploadFile };
